import { render, staticRenderFns } from "./Quizes.vue?vue&type=template&id=28742dcc"
import script from "./Quizes.vue?vue&type=script&lang=js"
export * from "./Quizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports